"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[6556],{

/***/ 39682:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62100);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69453);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78364);






var fitToClassName = {
    cover: "object-cover",
    contain: "object-contain"
};
// It helps to create placeholders for images
var AspectContainer = function(props) {
    var children = props.children, className = props.className, _props_aspect = props.aspect, aspect = _props_aspect === void 0 ? 1 : _props_aspect, _props_fit = props.fit, fit = _props_fit === void 0 ? "cover" : _props_fit, dataTestId = props["data-testid"];
    var placeholderStyle = {
        paddingTop: "".concat(Math.round(100 / aspect), "%")
    };
    var childClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("absolute left-0 top-0 h-full w-full", children.props.className, fitToClassName[fit]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(className, !(className === null || className === void 0 ? void 0 : className.includes("absolute")) && "relative"),
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                style: placeholderStyle
            }),
            /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.cloneElement(children, {
                className: childClassName
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AspectContainer);


/***/ }),

/***/ 10430:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Bone_Bone)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
;// CONCATENATED MODULE: ./src/components/layout/Bone/Bone.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Bone_module = ({"skeleton":"UG_B9X","shine-lines":"VCj7Eb"});
;// CONCATENATED MODULE: ./src/components/layout/Bone/Bone.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}





var Bone = function(props) {
    var className = props.className, width = props.w, height = props.h, percentWidth = props.pw, percentHeight = props.ph, aspect = props.aspect, circle = props.circle, _props_inline = props.inline, inline = _props_inline === void 0 ? false : _props_inline, _props_bgColor = props.bgColor, bgColor = _props_bgColor === void 0 ? "gray-20" : _props_bgColor;
    var style = (0,react.useMemo)(function() {
        var style = {};
        if (width) {
            style.width = style.minWidth = "".concat(width, "rem");
        }
        if (percentWidth) {
            style.width = style.minWidth = "".concat(percentWidth, "%");
        }
        if (height) {
            style.height = style.minHeight = "".concat(height, "rem");
        }
        if (percentHeight) {
            style.height = style.minHeight = "".concat(percentHeight, "%");
        }
        return style;
    }, [
        width,
        height,
        percentWidth,
        percentHeight
    ]);
    var skeletonClassName = (0,clsx/* default */.Z)("relative overflow-hidden", Bone_module.skeleton, className, _define_property({
        "inline-block": inline,
        "rounded-full": circle
    }, "bg-".concat(bgColor), bgColor));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: skeletonClassName,
        style: style,
        children: aspect && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                paddingTop: "".concat(Math.round(100 / aspect), "%")
            }
        })
    });
};
/* harmony default export */ const Bone_Bone = (/*#__PURE__*/react.memo(Bone));


/***/ }),

/***/ 67613:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export colorToClassName */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);



var colorToClassName = {
    "gray-30": "text-gray-30",
    "gold-50": "text-gold-50"
};
var Divider = function(props) {
    var className = props.className, _props_color = props.color, color = _props_color === void 0 ? "gray-30" : _props_color;
    var rootClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("h-1 bg-[currentColor]", colorToClassName[color], className);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: rootClassName
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Divider);


/***/ }),

/***/ 53285:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ZP: () => (/* binding */ Grid_Grid)
});

// UNUSED EXPORTS: aligns, columnsSizes, gutterSizes, justifies

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(56690);
;// CONCATENATED MODULE: ./src/components/layout/Grid/Cell/Cell.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




var Cell = function(props) {
    var children = props.children, className = props.className, _props_tag = props.tag, tag = _props_tag === void 0 ? "div" : _props_tag, _props_size = props.size, size = _props_size === void 0 ? 1 : _props_size, tabIndex = props.tabIndex, ariaLabelledby = props["aria-labelledby"];
    var rootClassName = (0,clsx/* default */.Z)(className, "mouse-focus:outline-none", _define_property({}, "col-span-".concat(size), Number(size) > 1));
    var nodeProps = {
        className: rootClassName,
        tabIndex: tabIndex,
        role: "listitem",
        "aria-labelledby": ariaLabelledby
    };
    return /*#__PURE__*/ react.createElement(tag, nodeProps, children);
};
/* harmony default export */ const Cell_Cell = (Cell);

;// CONCATENATED MODULE: ./src/components/layout/Grid/Grid.tsx
function Grid_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}





var aligns = (/* unused pure expression or super */ null && ([
    "center",
    "start",
    "end",
    "baseline",
    "stretch"
]));
var justifies = (/* unused pure expression or super */ null && ([
    "between",
    "center",
    "start",
    "end"
]));
var columnsSizes = (/* unused pure expression or super */ null && ([
    1,
    2,
    3,
    4,
    5,
    6,
    "2-center",
    "3-center",
    "6-center"
]));
var gutterSizes = (/* unused pure expression or super */ null && ([
    8,
    12,
    16,
    24,
    32
]));
var Grid = function(props) {
    var children = props.children, className = props.className, _props_columns = props.columns, columns = _props_columns === void 0 ? 1 : _props_columns, gutter = props.gutter, _props_align = props.align, align = _props_align === void 0 ? "start" : _props_align, _props_justify = props.justify, justify = _props_justify === void 0 ? "start" : _props_justify, _props_role = props.role, role = _props_role === void 0 ? "list" : _props_role, noWrap = props.noWrap, dataTestId = props["data-testid"];
    var _obj;
    var rootClassName = (0,clsx/* default */.Z)(className, "grid", (_obj = {
        "grid-flow-col": noWrap
    }, Grid_define_property(_obj, "items-".concat(align), align), Grid_define_property(_obj, "grid-cols-".concat(columns), columns), Grid_define_property(_obj, "justify-".concat(justify), justify), Grid_define_property(_obj, "gap-".concat(gutter), gutter), _obj));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: rootClassName,
        role: role,
        "data-testid": dataTestId,
        children: children
    });
};
Grid.Cell = Cell_Cell;
/* harmony default export */ const Grid_Grid = (Grid);


/***/ }),

/***/ 98669:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   rU: () => (/* binding */ createFallback)
/* harmony export */ });
/* unused harmony exports defaultFallback, widthContainerFallback */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _Bone_Bone__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10430);
/* harmony import */ var _WidthContainer_WidthContainer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24113);
/**
 * This component helps to lazy-load components
 */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}






var IntersectionVisible = function(props) {
    var className = props.className, children = props.children, _props_fallback = props.fallback, fallback = _props_fallback === void 0 ? defaultFallback : _props_fallback, _props_observerProps = props.observerProps, observerProps = _props_observerProps === void 0 ? {
        rootMargin: "50%"
    } : _props_observerProps;
    var isBot = useDevice().isBot;
    var _useEntry = _sliced_to_array(useEntry({
        once: true,
        observerProps: observerProps
    }), 2), containerRef = _useEntry[0], entry = _useEntry[1];
    var isVisible = isBot || (entry === null || entry === void 0 ? void 0 : entry.isIntersecting);
    return /*#__PURE__*/ _jsx("div", {
        ref: containerRef,
        className: className,
        children: isVisible ? children : fallback
    });
};
var createFallback = function(options) {
    var bone = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Bone_Bone__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        pw: 100,
        h: options.h
    });
    if (options.widthContainer) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_WidthContainer_WidthContainer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            children: bone
        });
    }
    return bone;
};
var defaultFallback = createFallback({
    h: 200,
    widthContainer: false
});
var widthContainerFallback = createFallback({
    h: 200,
    widthContainer: true
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (IntersectionVisible)));


/***/ }),

/***/ 11697:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Overlay_Overlay)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.timers.js
var web_timers = __webpack_require__(73598);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
;// CONCATENATED MODULE: ./src/components/layout/Overlay/Overlay.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Overlay_module = ({"overlay":"tLVDDZ","openOverlay":"S8968W","mounted":"_pY0DF"});
;// CONCATENATED MODULE: ./src/components/layout/Overlay/Overlay.tsx





var Overlay = function(param) {
    var children = param.children, className = param.className, onClick = param.onClick;
    var ref = (0,react.useRef)();
    (0,react.useEffect)(function() {
        // ATTN this workaround required to fix transition animation glitch (elements jumping from top to down when moving)
        //  timeout means that animation is finished
        var timer = setTimeout(function() {
            if (ref.current) {
                ref.current.classList.add(Overlay_module.mounted);
            }
        }, 400);
        return function() {
            clearTimeout(timer);
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        className: (0,clsx/* default */.Z)(Overlay_module.overlay, "inset-0", className),
        onClick: onClick,
        children: children
    });
};
/* harmony default export */ const Overlay_Overlay = (Overlay);


/***/ }),

/***/ 89902:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78364);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47361);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




var PageLayout = function(props) {
    var children = props.children, className = props.className, _props_withPaddingTop = props.withPaddingTop, withPaddingTop = _props_withPaddingTop === void 0 ? true : _props_withPaddingTop, _props_withPaddingBottom = props.withPaddingBottom, withPaddingBottom = _props_withPaddingBottom === void 0 ? true : _props_withPaddingBottom;
    var isMobile = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isMobile;
    var topClassName = isMobile ? "pt-40" : "pt-48";
    var bottomClassName = isMobile ? "pb-64" : "pb-80";
    var _obj;
    var rootClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(className, (_obj = {}, _define_property(_obj, topClassName, withPaddingTop), _define_property(_obj, bottomClassName, withPaddingBottom), _obj));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: rootClassName,
        children: children
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PageLayout);


/***/ }),

/***/ 71462:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78364);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47361);




var ScrollableContainer = function(props) {
    var children = props.children, className = props.className, _props_isDesktopEnabled = props.isDesktopEnabled, isDesktopEnabled = _props_isDesktopEnabled === void 0 ? false : _props_isDesktopEnabled;
    var isMobile = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isMobile;
    var containerClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(className, isMobile && "-mx-16 touch-manipulation px-16", (isMobile || isDesktopEnabled) && "no-scrollbar overflow-x-auto overflow-y-hidden");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: containerClassName,
        children: children
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ScrollableContainer);


/***/ }),

/***/ 8699:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ SideBySideLayout_SideBySideLayout)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
;// CONCATENATED MODULE: ./src/components/layout/SideBySideLayout/SideBySideLayout.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const SideBySideLayout_module = ({"container":"i5hgvu"});
;// CONCATENATED MODULE: ./src/components/layout/SideBySideLayout/SideBySideLayout.tsx





var SideBySideLayout = function(props) {
    var className = props.className, children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainer/* default */.Z, {
        className: (0,clsx/* default */.Z)(className, SideBySideLayout_module.container),
        children: children
    });
};
/* harmony default export */ const SideBySideLayout_SideBySideLayout = (SideBySideLayout);


/***/ }),

/***/ 53046:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ StickyFooterContainer_StickyFooterContainer)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
;// CONCATENATED MODULE: ./src/components/layout/StickyFooterContainer/StickyFooterContainer.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const StickyFooterContainer_module = ({"root":"xFFca1","top":"be2u4G","bottom":"bCLoLZ","visible":"GqqATU"});
;// CONCATENATED MODULE: ./src/components/layout/StickyFooterContainer/StickyFooterContainer.tsx




var StickyFooterContainer = function(props) {
    var children = props.children, className = props.className, _props_bgColor = props.bgColor, bgColor = _props_bgColor === void 0 ? "bg-gold-30" : _props_bgColor, _props_position = props.position, position = _props_position === void 0 ? "bottom" : _props_position, _props_isVisible = props.isVisible, isVisible = _props_isVisible === void 0 ? true : _props_isVisible, dataTestId = props["data-testid"];
    var rootClassName = (0,clsx/* default */.Z)(className, bgColor, StickyFooterContainer_module.root, isVisible && StickyFooterContainer_module.visible, "fixed inset-x-0 z-floating-header", position === "top" ? "top-0" : "bottom-0", StickyFooterContainer_module[position]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: rootClassName,
        "data-testid": dataTestId,
        children: children
    });
};
/* harmony default export */ const StickyFooterContainer_StickyFooterContainer = (StickyFooterContainer);


/***/ }),

/***/ 63208:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var react_helmet_async__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75479);



var htmlAttributes = {
    // @ts-ignore there is an error in typings of Helmet
    style: "background-color:#fff"
};
var WhitePageLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_helmet_async__WEBPACK_IMPORTED_MODULE_2__/* .Helmet */ .ql, {
                htmlAttributes: htmlAttributes
            }),
            children
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (WhitePageLayout);


/***/ }),

/***/ 24113:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);



var WidthContainer = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    var children = props.children, id = props.id, className = props.className, ignore = props.ignore, _props_size = props.size, size = _props_size === void 0 ? 1136 : _props_size, dataTestId = props["data-testid"];
    var rootClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, {
        "px-16 mx-auto": !ignore,
        "max-w-1440": !ignore && size === 1440,
        "max-w-1312": !ignore && size === 1312,
        "max-w-1168": !ignore && size === 1136,
        "max-w-976": !ignore && size === 944
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        id: id,
        className: rootClassName,
        "data-testid": dataTestId,
        children: children
    });
});
WidthContainer.displayName = "WidthContainer";
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (WidthContainer);


/***/ }),

/***/ 34626:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);



var WidthContainerCompensator = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    var className = props.className, children = props.children, dataTestId = props["data-testid"];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, "-mx-16"),
        "data-testid": dataTestId,
        children: children
    });
});
WidthContainerCompensator.displayName = "WidthContainerCompensator";
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (WidthContainerCompensator);


/***/ })

}]);